import { ReactNode, useState } from "react";
import { ExpandableSectionContext } from "./context";
import { Toggle } from "./Toggle";
import { Content } from "./Content";

type ExpandableSectionProps = {
  children: ReactNode;
  expanded?: boolean;
};

export const ExpandableSection = ({
  children,
  expanded = false,
}: ExpandableSectionProps) => {
  const [isExpanded, toggle] = useState(expanded);

  return (
    <ExpandableSectionContext.Provider value={{ isExpanded, toggle }}>
      <div>{children}</div>
    </ExpandableSectionContext.Provider>
  );
};

ExpandableSection.Toggle = Toggle;
ExpandableSection.Content = Content;
